import * as THREE from 'three';
import { PainterContext, TransitionPainter } from '../types';
import { easeInOutCubic } from '../easing';

/**
 * Slide: a full-height colored panel sweeps left-to-right on exit,
 * then off to the right on enter.
 */
export function createSlidePainter(): TransitionPainter {
  let mesh: THREE.Mesh | null = null;
  let ctxRef: PainterContext | null = null;

  return {
    setup(ctx) {
      ctxRef = ctx;
      const geo = new THREE.PlaneGeometry(1, 4);
      const mat = new THREE.MeshBasicMaterial({ color: ctx.color });
      mesh = new THREE.Mesh(geo, mat);
      mesh.visible = false;
      ctx.scene.add(mesh);
    },
    update(phase, t) {
      if (!mesh || !ctxRef) return;
      const eased = easeInOutCubic(t);
      const aspect = ctxRef.aspect;
      // Panel width = 2*aspect (full screen width in ortho units)
      const w = 2 * aspect;
      mesh.scale.x = w;
      // exit: x goes from -2w → 0 (fully covering)
      // enter: x goes from 0 → 2w (sliding off right)
      mesh.position.x = phase === 'exit' ? -w + eased * w : eased * w;
      mesh.visible = true;
    },
    hide() {
      if (mesh) mesh.visible = false;
    },
    dispose() {
      if (mesh) {
        mesh.geometry.dispose();
        (mesh.material as THREE.Material).dispose();
      }
      mesh = null;
      ctxRef = null;
    },
  };
}
